import Request from './Request';

export interface IScoreboard {
    id: number;
    name: string;
    code: string;
    actual: number;
    planSRE: number;
	planFRE: number;
	planBusinessPlan: number;
    active: boolean;
    children: IScoreboard[];
}

class Score {
    static Get = (id: number): IScoreboard => { return Request.DoGet('scoreboard/' + id) as unknown as IScoreboard; };
    static GetByCode = (code: string, year: number, month: number): IScoreboard => { return Request.DoGet('scoreboard/' + code + "/" + year + "/" + month) as unknown as IScoreboard; };
    static GetYTDByCode = (code: string, year: number, month: number): IScoreboard => { return Request.DoGet('scoreboard/ytd/' + code + "/" + year + "/" + month) as unknown as IScoreboard; };
}

export default Score;